import * as Types from '../../tenants/kwg/generated';

import { RoleAssignmentFragmentDoc } from '../roleAssigments/roleAssignments.fragment.g';
import { GroupFragmentDoc } from '../groups/groups.fragment.g';

export const UserFragmentDoc = `
    fragment User on User {
  id
  name
  email
}
    `;
export const MeFragmentDoc = `
    fragment Me on User {
  id
  name
  email
  signatureInitials
  roleAssignments(first: 100) {
    nodes {
      ...RoleAssignment
    }
  }
  groups(first: 100) {
    nodes {
      ...Group
    }
  }
}
    `;
export const UserDetailFragmentDoc = `
    fragment UserDetail on User {
  id
  name
  loginName
  email
  workPhone
  initials
  signatureInitials
  securityIdentifier
  isActive
  groups(first: 100) {
    nodes {
      ...Group
    }
  }
  roleAssignments(first: 100) {
    nodes {
      ...RoleAssignment
    }
  }
}
    `;
// @ts-ignore
// auto-added to satisfy TS unused import
void 0 && Types;
